import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class CommentWrittenJournalEvent extends JournalEvent {
  static override type = "comment-written-journal-event";

  @attr("string") declare comment: string;

  static override validations(intl: IntlService) {
    return {
      comment: validatePresence({
        presence: true,
        description: intl.t("validations.comment-written-journal-event.comment")
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.comment-written-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("journal-event", {
    async: false,
    inverse: "commentWrittenJournalEvents",
    polymorphic: true,
    as: "journal-event"
  })
  declare originJournalEvent: JournalEvent;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "comment-written-journal-event": CommentWrittenJournalEvent;
  }
}
